import Currency from '@/models/currency'

export const MINIMAL_PAYMENT_AMOUNT_CENTS = 100

export default interface Payment {
  id: number
  bookingId: number
  refundedPaymentId: number
  amountCents: number
  refundedAmountCents: number
  amountAllocated: number
  createdAt: string
  chargeBy: string
  passengerPayerId?: number
  lastFour: string
  payType: PayTypes
  isRefund: boolean
  isTransfer: boolean
  cardHolder: string
  currencyCode: Currency
  cardBrand: string
}

export enum PayTypes {
  Bank = 'bank',
  Card = 'card',
  Cash = 'cash',
  Transfer = 'transfer',
  Credit = 'credit',
}
